var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"todoPage"},[_c('h1',[_vm._v("To Do")]),_c('todo-list',{attrs:{"list":_vm.todoList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }